import DeleteIcon from "@mui/icons-material/Delete";
import UploadIcon from "@mui/icons-material/Upload";
import { Box, FormHelperText, IconButton, TextField, Typography } from "@mui/material";
import React from "react";
import { ITheme } from "../../utils/theme";

interface IFileUploadFieldProps {
  label?: string;
  files?: File[] | [];
  required?: boolean;
  error?: string | JSX.Element
  disabled?: boolean;
  onFileChange: (files: FileList | []) => void;
  onRemoveFile: (index: number) => void;
}

export const FileUploadField: React.FC<IFileUploadFieldProps> = ({
  label = "",
  onFileChange,
  onRemoveFile,
  files = [],
  required = false,
  error = '',
  disabled = false,
}) => (
  <Box>
    {label && (
      <Typography variant="form-label" sx={{ fontWeight: "normal" }}>
        {label}
        {required && (
          <Typography component="span" sx={{ color: (theme: ITheme) => theme.palette.red.A700, ml: 0.5 }}>
            *
          </Typography>
        )}
      </Typography>
    )}
    <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
      <TextField
        fullWidth
        type="text"
        value={files && files.length > 0 ? Array.from(files).map((file) => file.name).join(", ") : ""}
        placeholder="No files selected"
        disabled={disabled}
        InputProps={{
          endAdornment: (
            <label htmlFor="file-upload">
              <input
                type="file"
                multiple
                accept=".pdf,.jpg,.png"
                onChange={(e) => {
                  onFileChange(e.target.files ?? [])
                  // fix same file upload after deletion
                  e.target.value = ''
                }}
                style={{ display: "none" }}
                id="file-upload"
                disabled={disabled}
              />
              <UploadIcon sx={(theme: ITheme) => ({ cursor: "pointer", fill: disabled ? 'grey' : theme.palette.clearBlue })} />
            </label>
          ),
        }}
        error={!!error}
      />
    </Box>

    {files && files.length > 0 && (
      <Box sx={{ mt: 1 }}>
        {Array.from(files).map((file, index) => (
          <Box key={index} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 1 }}>
            <Typography sx={{ fontSize: 14, wordBreak: "break-word" }}>{file.name}</Typography>
            <IconButton size="small" onClick={() => onRemoveFile(index)} sx={{ color: "red" }}>
              <DeleteIcon />
            </IconButton>
          </Box>
        ))}
      </Box>
    )}
    {error && <FormHelperText
      component={'div'}
      error={!!error}
    >
      {error}
    </FormHelperText>}
  </Box>
);
